module.exports = __webpack_public_path__ + "img/navbg.05f2de86.png";